import { CreateControllerFn } from '@wix/yoshi-flow-editor';
import { searchAppControllerFactory } from './platform/controllerFactory';
import {
  createGetAppSettings,
  createSearchSDK,
} from '../../lib/extendControllerParams';
import { createSearchLocation } from '../../lib/location';

const createController: CreateControllerFn = async (params) => {
  const { flowAPI, controllerConfig } = params;
  return searchAppControllerFactory({
    ...controllerConfig,
    getAppSettings: createGetAppSettings(params),
    searchLocation: createSearchLocation(controllerConfig.wixCodeApi),
    searchSDK: createSearchSDK(params),
    flowAPI,
    isProductSlotInstalled: false,
  });
};

export default createController;
